<template>
  <section class="device-showcase-section">
    <!-- layered backgrounds -->
    <div
      class="bg-layer bg-base"
      :style="{ backgroundImage: 'url(/assets/bg.svg)' }"
    />
    <div
      class="bg-layer bg-masthead"
      :style="{ backgroundImage: 'url(/assets/bg-masthead.svg)' }"
    />

    <v-container style="max-width: 860px; position: relative; z-index: 1">
      <div class="text-center mb-10">
        <p class="showcase-eyebrow">{{ $t('deviceShowcase.eyebrow') }}</p>
        <h2 class="showcase-headline">{{ $t('deviceShowcase.headline') }}</h2>
        <p class="showcase-sub mx-auto">{{ $t('deviceShowcase.sub') }}</p>
      </div>

      <div class="device-wrap">
        <div class="device-frame">
          <img src="/assets/ipad.png" alt="iPad frame" class="device-img" />
          <img src="/assets/dashboard.png" alt="Dashboard" class="dashboard-screen" />
        </div>
      </div>

      <!-- Search bar -->
      <div class="search-wrap anim anim-3">
        <v-icon class="search-icon" color="#aaa" size="20">mdi-magnify</v-icon>
        <input
          class="search-input"
          type="text"
          :placeholder="$t('hero.searchPlaceholder')"
        />
        <button class="search-btn">
          <v-icon color="white" size="20">mdi-magnify</v-icon>
        </button>
      </div>

      <!-- Inline stats -->
      <div class="stats-row anim anim-4">
        <div class="stat-item">
          <div class="stat-icon-wrap">
            <v-icon color="primary" size="20">mdi-file-document-outline</v-icon>
          </div>
          <div>
            <p class="stat-val">{{ $t('hero.stat1Val') }}</p>
            <p class="stat-lbl">{{ $t('hero.stat1Label') }}</p>
          </div>
        </div>
        <div class="stat-divider" />
        <div class="stat-item">
          <div class="stat-icon-wrap">
            <v-icon color="primary" size="20">mdi-school-outline</v-icon>
          </div>
          <div>
            <p class="stat-val">{{ $t('hero.stat2Val') }}</p>
            <p class="stat-lbl">{{ $t('hero.stat2Label') }}</p>
          </div>
        </div>
        <div class="stat-divider" />
        <div class="stat-item">
          <div class="stat-icon-wrap">
            <v-icon color="primary" size="20">mdi-earth</v-icon>
          </div>
          <div>
            <p class="stat-val">{{ $t('hero.stat3Val') }}</p>
            <p class="stat-lbl">{{ $t('hero.stat3Label') }}</p>
          </div>
        </div>
      </div>

      <!-- CTA buttons -->
      <div class="cta-row anim anim-5">
        <v-btn color="primary" depressed large rounded class="cta-primary px-8">
          {{ $t('hero.cta1') }}
        </v-btn>
        <v-btn outlined large rounded class="cta-secondary px-7">
          <v-icon left size="18">mdi-play-circle-outline</v-icon>
          {{ $t('hero.cta2') }}
        </v-btn>
      </div>

      <!-- Trust row -->
      <div class="trust-row anim anim-6">
        <p class="trust-text">
          {{ $t('hero.trustPrefix') }}
          <span class="trust-highlight">{{ $t('hero.trustHighlight') }}</span>
          {{ $t('hero.trustSuffix') }}
        </p>
        <div class="stars mt-1">
          <v-icon v-for="n in 5" :key="n" color="#FFB800" size="18">mdi-star</v-icon>
        </div>
      </div>

    </v-container>
  </section>
</template>

<script>
export default {
  name: 'DeviceShowcase',
}
</script>

<style scoped>
.device-showcase-section {
  position: relative;
  overflow: hidden;
  padding: 100px 16px 0;
  background: #fdf8ee;
}

.bg-layer {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  pointer-events: none;
}

.bg-base {
  z-index: 0;
  top: -40px;
  left:-100px;
}

.bg-masthead {
  z-index: 0;
  inset: auto;
  right: 0;
  top: 300px;
  bottom: 0;
  left: auto;
  width: 20%;
  background-size: contain;
  background-position: right top;
  opacity: 0.9;
}

.showcase-eyebrow {
  font-size: 0.78rem;
  font-weight: 700;
  color: #f97316;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 12px;
}

.showcase-headline {
  font-size: 2.6rem;
  font-weight: 900;
  color: #1a1a2e;
  letter-spacing: -1.5px;
  line-height: 1.15;
  margin-bottom: 16px;
}

@media (max-width: 768px) {
  .showcase-headline {
    font-size: 1.9rem;
    letter-spacing: -0.8px;
  }
}

.showcase-sub {
  font-size: 1rem;
  color: #666;
  line-height: 1.75;
  max-width: 520px;
  margin: 0 auto;
}

.device-wrap {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.device-frame {
  position: relative;
  width: 100%;
  max-width: 860px;
}

.device-img {
  width: 100%;
  height: auto;
  display: block;
  position: relative;
  z-index: 2;
}

/* Positioned exactly over the screen area (measured from ipad.png 800×545px):
   screen rows 22–510 → top 4.04%, height 89.5%
   screen cols 51–746 → left 6.375%, width 86.875% */
.dashboard-screen {
  position: absolute;
  top: 4.04%;
  left: 6.375%;
  width: 86.875%;
  height: 89.5%;
  object-fit: cover;
  object-position: top left;
  z-index: 1;
  border-radius: 3px;
}

@keyframes fade-up {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}

.anim {
  opacity: 0;
  animation: fade-up 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
.anim-3 { animation-delay: 0.25s; }
.anim-4 { animation-delay: 0.35s; }
.anim-5 { animation-delay: 0.45s; }
.anim-6 { animation-delay: 0.55s; }

.search-wrap {
  display: flex;
  align-items: center;
  background: white;
  border: 1.5px solid #e5e7eb;
  border-radius: 100px;
  padding: 6px 6px 6px 18px;
  max-width: 580px;
  margin: 36px auto 36px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.search-wrap:focus-within {
  border-color: #4257b2;
  box-shadow: 0 4px 24px rgba(66, 87, 178, 0.14);
}

.search-icon { flex-shrink: 0; margin-right: 10px; }

.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 0.95rem;
  color: #374151;
  background: transparent;
  font-family: inherit;
  min-width: 0;
}

.search-input::placeholder { color: #9ca3af; }

.search-btn {
  width: 44px;
  height: 44px;
  border-radius: 100px;
  background: #3BD081;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.2s, transform 0.15s;
}

.search-btn:hover {
  background: #3348a0;
  transform: scale(1.05);
}

.stats-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  margin-bottom: 36px;
  flex-wrap: wrap;
}

.stat-item { display: flex; align-items: center; gap: 10px; }

.stat-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eef0fb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-val {
  font-size: 1rem;
  font-weight: 800;
  color: #1a1a2e;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.3px;
}

.stat-lbl {
  font-size: 0.75rem;
  color: #9ca3af;
  margin: 0;
  font-weight: 500;
}

.stat-divider {
  width: 1px;
  height: 32px;
  background: #e5e7eb;
}

@media (max-width: 480px) {
  .stat-divider { display: none; }
}

.cta-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 32px;
}

.cta-primary {
  text-transform: none !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  height: 52px !important;
  box-shadow: 0 4px 20px rgba(66, 87, 178, 0.35) !important;
}

.cta-secondary {
  text-transform: none !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  height: 52px !important;
  color: #374151 !important;
  border-color: #d1d5db !important;
}

.trust-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding-bottom: 48px;
}

.trust-text {
  font-size: 0.9rem;
  color: #6b7280;
  margin: 0;
  font-weight: 500;
}

.trust-highlight {
  color: ##3BD081;
  font-weight: 700;
}

.stars { display: flex; gap: 2px; }
</style>
